import {useTranslation} from 'react-i18next'
import {EntitySearchSelect} from '@/components/entity-search-select'
import type {Employee} from '@/hooks/empresa/identidad/use-employees'

/** Searchable combobox (R3): the verified roster grows as more Inci staff get their licencia SST. */
export function PsicologoSelect({
  id,
  psicologos,
  value,
  onChange,
  testId,
}: {
  id: string
  psicologos: Employee[]
  value: string
  onChange: (userId: string) => void
  testId: string
}) {
  const {t} = useTranslation()
  const selected = psicologos.find((p) => p.user_id === value) ?? null
  return (
    <EntitySearchSelect
      items={psicologos}
      value={selected}
      getKey={(p) => p.user_id}
      filterText={(p) => `${p.name} ${p.last_name} ${p.cedula}`}
      renderOption={(p) => (
        <span>
          {p.name} {p.last_name}
        </span>
      )}
      renderTriggerValue={(p) => (
        <span>
          {p.name} {p.last_name}
        </span>
      )}
      placeholder={t('admin.bateria.nuevaDialog.psicologoPlaceholder')}
      searchPlaceholder={t('admin.bateria.nuevaDialog.psicologoSearchPlaceholder')}
      noResultsLabel={t('admin.bateria.nuevaDialog.psicologoNoResults')}
      testId={testId}
      id={id}
      onPick={(p) => onChange(p?.user_id ?? '')}
    />
  )
}
